import React, { FC, useEffect, useState } from "react";
import { debounce } from "lodash";
import { useForm } from "react-hook-form/dist/index.ie11";
import { useTranslation } from "react-i18next";

import useDebounce from "~/shared/hooks/useDebounce";
import Input from "~/shared/ui/Fields/Input";
import { useGetLocationData, useSetLocationData } from "~/hooks/locationData";
import { Dealer } from "~/schemas/generated/graphql";

import s from "./Search.less";

interface IProps {
  CleanInput?: boolean;
  onSearch?: (value: string) => void;
}

const Search: FC<IProps> = ({ CleanInput = false, onSearch }) => {
  const { t } = useTranslation();
  const setData = useSetLocationData();
  const { searchText, searchField } = useGetLocationData();
  const { control, watch, setValue } = useForm();
  const searchInputValue = watch("search");
  const debounceVal = useDebounce(searchInputValue, 700);

  useEffect(() => {
    if (debounceVal) {
      setData("searchText", debounceVal, "page", 0);
      onSearch?.(debounceVal);
    } else {
      setData("searchText", "", "page", 0);
      onSearch?.("");
    }
  }, [debounceVal]);

  useEffect(() => {
    if (CleanInput) {
      setData("searchText", "", "page", 0);
      setValue("search", "");
    }
  }, [searchField]);

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      // Perform your search logic here
      // For example, you might want to call a search function or update the state with the search text.
      console.log("Search for:", searchText);
    }
  };

  return (
    <div className={s.header_search}>
      <form>
        <Input
          search
          type="text"
          name="search"
          placeholder={t("ui.search")}
          defaultValue={searchText}
          onKeyDown={handleKeyPress}
          control={control}
        />
      </form>
    </div>
  );
};

export default Search;
